<template>
  <section class="panel" aria-label="Ad-Ons Information">
    <div class="panel__title">{{ $t('licensing.settings.addons.title') }}</div>
    <div class="addons-chips" role="list" aria-label="Add-ons status">
      <v-tooltip
        v-for="addon in addonList"
        :key="addon.key"
        top
        max-width="280"
        content-class="addon-tooltip"
      >
        <template #activator="{ on, attrs }">
          <span
            role="listitem"
            class="addon-chip"
            :class="addon.active ? 'addon-chip--active' : 'addon-chip--inactive'"
            v-bind="attrs"
            v-on="on"
          >
            <v-icon x-small :color="addon.active ? 'success' : 'grey'">
              {{ addon.active ? 'check_circle' : 'remove_circle_outline' }}
            </v-icon>
            {{ addon.label }}
          </span>
        </template>
        <span>{{ $t('licensing.settings.addons.tooltip.' + addon.key) }}</span>
      </v-tooltip>
    </div>
  </section>
</template>

<script>
export default {
  name: 'LicenseAddonsPanel',
  props: {
    addonList: { type: Array, required: true },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/_sizing";
@import "@/assets/styles/_colors";
@import "@/assets/styles/_semantic-sizing";

.panel {
  background: var(--bg-secondary);
  border: $border-width-thin solid var(--border-primary);
  border-radius: $radius-lg;
  padding: $space-5 $space-6;

  &__title {
    color: var(--text-primary);
    font-family: $font-family-bold;
    font-size: $font-size-base;
    margin-bottom: $space-4;
    padding-bottom: $space-2;
    border-bottom: $border-width-thin solid var(--border-primary);
  }
}

.addons-chips {
  display: flex;
  flex-wrap: wrap;
  gap: $space-2;
}

.addon-chip {
  display: inline-flex;
  align-items: center;
  gap: $space-1-5;
  padding: $space-1-5 $space-3;
  border-radius: $radius-full;
  font-family: $font-family-regular;
  font-size: $font-size-sm;
  white-space: nowrap;
  cursor: default;

  &--active { background: $success-50; color: $success-500; }
  &--inactive { background: var(--bg-tertiary, $gray-100); color: var(--text-secondary); }
}
</style>

<style lang="scss">
/* Unscoped — Vuetify tooltips render outside component scope */
.addon-tooltip {
  font-size: 14px !important;
  line-height: 1.5 !important;
  padding: 8px 14px !important;
}
</style>
